import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin, Award, Target } from 'lucide-react';
import { companyInfo } from '../data/mockData';

const About = () => {
  return (
    <div className="page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <div className="page-hero-content">
            <h1 className="heading-1">About Full-Bin UK</h1>
            <p className="body-large">
              UK-based sustainability and IoT technology company. We help businesses reduce costs, monitor operations, and improve environmental performance.
            </p>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="section">
        <div className="container">
          <div className="mission-content">
            <div className="mission-text">
              <h2 className="heading-2">Our Mission</h2>
              <p className="body-large">
                To deliver practical, proven technology that makes sustainability profitable for UK businesses.
              </p>
              <p className="body-medium">
                We believe environmental responsibility and operational efficiency go hand in hand. Through smart energy optimization, real-time monitoring, and ESG support, we help organizations reduce their environmental impact while lowering costs.
              </p>
              <p className="body-medium">
                No corporate buzzwords. No empty promises. Just reliable technology and measurable results.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section bg-section">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-2">Our Approach</h2>
          </div>

          <div className="values-grid">
            <div className="value-item">
              <Target size={32} />
              <h3 className="heading-3">Results-Focused</h3>
              <p className="body-medium">
                We measure success in tangible outcomes: energy savings, cost reductions, and sustainability improvements you can track.
              </p>
            </div>

            <div className="value-item">
              <Award size={32} />
              <h3 className="heading-3">Proven Technology</h3>
              <p className="body-medium">
                OH4 energy optimization and IoT sensor systems deployed across commercial, industrial, and hospitality sectors in the UK.
              </p>
            </div>

            <div className="value-item">
              <MapPin size={32} />
              <h3 className="heading-3">UK Expertise</h3>
              <p className="body-medium">
                Built for UK businesses. We understand local regulations, climate conditions, and operational requirements.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What We Do */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-2">What We Do</h2>
          </div>

          <div className="services-overview">
            <div className="service-overview-item">
              <h3 className="heading-3">Energy Optimization</h3>
              <p className="body-medium">
                Our OH4 system reduces HVAC and chiller energy consumption by 15-30% through intelligent, continuous optimization. Non-invasive installation with no performance compromise.
              </p>
            </div>

            <div className="service-overview-item">
              <h3 className="heading-3">IoT Monitoring</h3>
              <p className="body-medium">
                Real-time sensor networks for energy, environmental conditions, equipment health, and space utilization. Cloud dashboards, mobile alerts, and automation capabilities.
              </p>
            </div>

            <div className="service-overview-item">
              <h3 className="heading-3">ESG Support</h3>
              <p className="body-medium">
                Practical ESG compliance, carbon footprint assessment, sustainability reporting, and improvement roadmaps for UK businesses.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Company Info */}
      <section className="section bg-section">
        <div className="container">
          <div className="company-info-grid">
            <div className="info-block">
              <h3 className="heading-3">Established</h3>
              <p className="body-medium">{companyInfo.founded}</p>
            </div>
            <div className="info-block">
              <h3 className="heading-3">Location</h3>
              <p className="body-medium">{companyInfo.location}</p>
            </div>
            <div className="info-block">
              <h3 className="heading-3">Focus</h3>
              <p className="body-medium">Energy Optimization, IoT Monitoring, ESG Compliance</p>
            </div>
            <div className="info-block">
              <h3 className="heading-3">Markets</h3>
              <p className="body-medium">Commercial, Industrial, Hospitality, Property Management</p>
            </div>
          </div>
        </div>
      </section>

      {/* Leadership */}
      <section className="section bg-section">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-2">Leadership</h2>
          </div>

          <div className="leadership-content">
            <div className="leader-card-clean">
              <div className="leader-info-clean">
                <h3 className="heading-3">{companyInfo.ceo}</h3>
                <p className="leader-title">Chief Executive Officer & Founder</p>
                <p className="body-medium">
                  Christian Herbert leads Full-Bin UK's mission to deliver practical sustainability solutions to UK businesses. With deep expertise in IoT technology and energy optimization, Christian focuses on proven technology, measurable results, and customer success.
                </p>
                <p className="body-medium">
                  Under his leadership, Full-Bin UK has deployed innovative solutions including the OH4 energy optimization system, Sensative IoT sensor networks, and Awaab's Law compliance systems across commercial and social housing sectors.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Recognition */}
      <section className="section bg-section">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-2">Recognition</h2>
          </div>

          <div className="recognition-grid">
            <div className="recognition-item">
              <Award size={32} />
              <div>
                <h3 className="heading-3">Top Innovative Companies 2024</h3>
                <p className="body-small">Recognized for innovation in waste management IoT and SaaS solutions</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="heading-2">Let's work together</h2>
            <p className="body-large">
              Ready to reduce costs and improve sustainability? Get in touch.
            </p>
            <Link to="/contact" className="btn-primary">
              Contact Us
              <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
